/* globals $ */

/**
 * This file is meant to duplicate logic that is found within Shopify Scripts, in order to display discounts
 * in other places beyond the cart, such as product lists. This logic is again duplicated within liquid at snippets/display-discount.liquid
 */

const DISCOUNTS = [
  {
    tag: 'Certified Teacher',
    message: 'Teachers discount applied',
    productTypes: ['Books'],
    /* excludeSkus: [], */ // leaving this out for now, since the sku is variant-level
    excludeTags: ['Discount:Exclude', 'TeacherDiscount:Exclude'],
    amount: 20
  }
]

/**
 * Checks if the logged in customer should receive a discount
 * @param {object} product - A product object
 * @returns {object} - A discount object containing { percentage, dollarAmount, finalPrice, message }, or false
 */
export function getCustomerDiscount (product) {
  if (!window.customer || !product) {
    return false
  }

  const {
    tags: customerTags
  } = window.customer

  if (!customerTags || !customerTags.length) {
    return false
  }

  const {
    product_type: productType1,
    type: productType2,
    tags: originalProductTags,
    price: productPrice
  } = product

  // the product object might be a different format, based on where it's coming from...
  const productTags = (typeof originalProductTags === 'string') ? originalProductTags.split('[:ATTR:]') : originalProductTags
  const productType = (typeof productType1 !== 'undefined') ? productType1 : productType2

  for (let i = 0, len = DISCOUNTS.length; i < len; i++) {
    const {
      tag,
      message,
      productTypes,
      /* excludeSkus, */
      excludeTags,
      amount: discountAmount
    } = DISCOUNTS[i]

    // check if the customer has proper tag
    if (customerTags.indexOf(tag) === -1) {
      continue
    }

    // check if product type has a discount
    if (productTypes.indexOf(productType) === -1) {
      continue
    }

    // exclude products with exclusion tags
    let exclude = false
    for (let ii = 0, len2 = excludeTags.length; ii < len2; ii++) {
      if (productTags.indexOf(excludeTags[ii]) > -1) {
        exclude = true
        break
      }
    }
    if (exclude) {
      continue
    }

    const dollarAmount = productPrice * (discountAmount / 100)
    const finalPrice = Math.max(productPrice - dollarAmount, 0)

    return {
      percentage: discountAmount,
      dollarAmount: dollarAmount,
      finalPrice: finalPrice,
      message: message
    }
  }

  return false
}
